/**
 * How a stop is named on the End of day lists: the site (location), the
 * position inside it (place) and the machine number (SPEC decision 6).
 */
export const getStopLabels = docket => ({
	site: docket?.machine?.location?.name || '',
	position: docket?.machine?.place?.name || '',
	machineNumber: docket?.machine?.assetId || '',
});

export const countLabel = (count, singular, plural) => `${count} ${count === 1 ? singular : plural}`;
